import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'sonner'
import { AuthProvider } from '@/contexts/auth-context'
import { ProtectedRoute } from '@/components/protected-route'
import Home from '@/pages/Home'
import Auth from '@/pages/Auth'
import Authorized from '@/pages/Authorized'
import VerifyOTP from '@/pages/VerifyOTP'
import GoogleCallback from '@/pages/GoogleCallback'
import Register from '@/pages/Register'
import ForgotPassword from '@/pages/ForgotPassword'

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/auth" element={<Auth />} />
        <Route path="/authorized" element={<Authorized />} />
        <Route path="/verify-otp" element={<VerifyOTP />} />
        <Route path="/auth/google/callback" element={<GoogleCallback />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* Protected route - requires authentication */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  )
}

export default App